import { AxiosError } from 'axios';

/** The code both transcript endpoints refuse an oversized file with. */
const FILE_TOO_LARGE_CODE = 'transcriptFileTooLarge';

/** The code both transcript endpoints refuse a file with when its extension is not one the journey reads. */
const UNSUPPORTED_FORMAT_CODE = 'transcriptUnsupportedFormat';

const refusalCode = (error: unknown): string | undefined =>
    error instanceof AxiosError && error.response?.status === 400
        ? (error.response.data as { error?: string } | undefined)?.error
        : undefined;

/**
 * The assessment and the thematic meeting transcripts share this refusal code but not the limit that
 * triggers it (10 MB against 2 MB): the caller says its own number back, so the generic upload
 * failure never borrows the other journey's.
 */
export const isTranscriptFileTooLargeError = (error: unknown): boolean =>
    refusalCode(error) === FILE_TOO_LARGE_CODE;

/**
 * Shared too, but not the extensions behind it: the thematic meeting also reads `.vtt`. The caller
 * words it with its own, so the manager is told exactly what to import (bug 17442).
 */
export const isTranscriptUnsupportedFormatError = (error: unknown): boolean =>
    refusalCode(error) === UNSUPPORTED_FORMAT_CODE;
